import styled from 'styled-components'

import { TypeStyle, fromMd } from '@syconium/little-miss-figgy'

import { useSiteWideMessaging } from '../../../app/_providers/SiteWideMessagingProvider.client'

export function IntlShippingAndTaxMsg() {
  const { siteWideRegionSpecificDutiesAndFeesMessage, siteWideRegionSpecificShippingMessage } =
    useSiteWideMessaging()
  return (
    <>
      {siteWideRegionSpecificShippingMessage && <div>{siteWideRegionSpecificShippingMessage}</div>}
      {siteWideRegionSpecificDutiesAndFeesMessage && (
        <IntlMsgWrap>{siteWideRegionSpecificDutiesAndFeesMessage}</IntlMsgWrap>
      )}
    </>
  )
}

const IntlMsgWrap = styled(TypeStyle.BodyNano)`
  font-weight: 600;
  text-wrap: pretty;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${o => o.theme.spacing(2)};
  text-align: center;

  margin: ${o => o.theme.spacing(6)};
  ${fromMd} {
    margin: ${o => o.theme.spacing(4)} 0;
  }
`
